import React, { useState, useEffect, useContext } from "react";
import { Link } from 'react-router-dom';
import EventContext from "../contexts/event";

const Footer: React.FC = () => {
  const eventContext = useContext(EventContext);
  return (
    <footer className="quiz-footer" style={{backgroundColor:'white'}}>

      <div>
      <span>Powered by</span>
      <img src="/images/e-slides-logo.png" alt="e-slides-logo" />
      </div>
      {/* <div className="d-flex flex-row ">
        <div className="p-2" > <Link to={`/${eventContext.slug}/quiz-questions`}  className="btn btn-next"> <b style={{color:'#24b2ff'}}>START QUIZ</b></Link>   </div>
      </div>
      <div className="d-flex flex-row-reverse ">
        <div>       <span>Powered by</span>
        <img src="/images/e-slides-logo.png" alt="e-slides-logo" /> </div>


      </div> */}
{/*
      <div className="container p-2 pb-0" style={{padding:10}}>

      <div className="">
        <p className="d-flex  align-items-center" style={{justifyContent:'space-between'}}>
        <div className="p-2" > <Link to={`/${eventContext.slug}/quiz-questions`}  className="btn btn-next"> <b style={{color:'#24b2ff'}}>START QUIZ</b></Link>   </div>

        <div>       <span>Powered by</span>
        <img src="/images/e-slides-logo.png" alt="e-slides-logo" /> </div>




        </p>
      </div>

    </div> */}
    </footer>
  )
}

export default Footer;
